<template>
    <div class="fixed shadow-[0_35px_60px_-15px_rgba(0,0,0,0.3)] top-[40%] left-[50%] bg-[#FFFFFF] border-[#C9ADA7] border-[1px] p-4 rounded-[10px] w-[300px]">
        <div class="text-center mb-3 text-[#525A60]">
            Ви дійсно хочете видалити адміна {{ admin.admin_name + ' ' + admin.admin_surname }}?
            <br>
            <span class="text-[11px]">(його баланси залишаться в системі для майбутніх транзакцій)</span>
        </div>
        <div class="flex justify-between">
            <button @click="deleteAdmin" class="bg-[#990D35] hover:bg-opacity-90 text-white px-4 py-1 rounded-[10px]">Так</button>
            <button @click="$emit('close')" class="px-4 py-1 rounded-[10px] text-white bg-[#525A60]">Ні</button>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'delete-admin-form',

        props: {
            admin: {
                type: Object,
                required: true
            }
        },

        setup(props, { emit }) {
            const deleteAdmin = () => {
                emit('acceptDeleteAdmin', props.admin)
            }

            return {
                deleteAdmin
            }
        }
    }
</script>
